import { useState } from "react";
import { useLocation } from "react-router-dom";
import { AlertTriangle, CreditCard } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export const openBillingPortal = async () => {
  const { data } = await api.post("/account/billing-portal", { origin_url: window.location.origin });
  window.location.href = data.url;
};

export const BillingBanner = () => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const [busy, setBusy] = useState(false);
  if (!user || !user.payment_failed || pathname === "/auth") return null;
  const go = async () => {
    setBusy(true);
    try { await openBillingPortal(); } catch (e) { toast.error(e.response?.data?.detail || "Could not open billing."); setBusy(false); }
  };
  return (
    <div className="bg-red-600 text-white" data-testid="billing-banner">
      <div className="max-w-6xl mx-auto px-4 py-2.5 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
        <p className="text-sm flex items-start gap-2 flex-1"><AlertTriangle className="w-4 h-4 mt-0.5 shrink-0" /><span><span className="font-bold">Your Premium payment didn't go through.</span> Premium is on hold until it does — update your card and access comes back the moment the payment succeeds. Your progress is safe.</span></p>
        <button type="button" onClick={go} disabled={busy} className="inline-flex items-center gap-2 self-start sm:self-auto rounded-full bg-white text-red-700 font-bold text-sm px-4 py-1.5 hover:bg-red-50 disabled:opacity-60 transition-colors" data-testid="billing-banner-update-card">
          <CreditCard className="w-4 h-4" /> Update card
        </button>
      </div>
    </div>
  );
};
